/* @flow */
import { HELPFUL_FETCH_CONTENT_DATA, HELPFUL_SCRIPT_LOADED } from '../constants/helpful';
import { FAIL, START, SUCCESS } from '../constants';
import { addJavaHeaders } from '../utils';

export const startFetchingContentData = () => ({ type: HELPFUL_FETCH_CONTENT_DATA + START });

export const setContentData = (contentData) => ({
	type: HELPFUL_FETCH_CONTENT_DATA + SUCCESS,
	payload: contentData,
});

export const fetchingContentDataError = () => ({ type: HELPFUL_FETCH_CONTENT_DATA + FAIL });

export const fetchContentData =
	() =>
	async (dispatch, getState, { fetch }) => {
		dispatch(startFetchingContentData());

		const {
			city,
			token: { token },
		} = getState();

		const contentUrl = '/lexsApi/content/useful';
		const fetchOptions = {
			method: 'POST',
			body: JSON.stringify({ cityIds: city.cityIds }),
			...addJavaHeaders(token),
		};

		fetch(contentUrl, fetchOptions)
			.then((data) => data.json())
			.then(({ data: contentData = null }) => {
				dispatch(setContentData(contentData));
			})
			.catch(() => {
				dispatch(fetchingContentDataError());
			});
	};

/**
 * Загрузка скриптов LivingPro для кабинета
 * @param loaded - boolean
 * @returns {{payload: boolean, type: string}}
 */
export const setScriptsLoaded = (loaded: boolean) => ({
	type: HELPFUL_SCRIPT_LOADED,
	payload: loaded,
});
